//Object => JSON
export const setLocalStorage = (key: string, value: any) => {
  //localStorage ne peut enregistrer un objet javaScript
  localStorage.setItem(key, JSON.stringify(value));
};

//JSON => Object
export const getLocalStorage = (key: string) => {
  const item = localStorage.getItem(key);
  return item ? JSON.parse(item) : null;
};

export const deleteLocalStorage = (key: string) => {
  localStorage.removeItem(key);
};
